module.exports = "\n<a v-if=\"preferences.searchVersion !== 2\" href=\"#\" class=\"btn btn-link\"\n   :aria-disabled=\"preferences.saving ? 'true' : 'false'\" @click.prevent=\"activate\">\n    {{ preferences.saving ? 'Ativando...' : 'Experimente a nova pesquisa' }}\n</a>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/property/NewSearchButton.vue
// module id = ./node_modules/vue-html-loader/index.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/property/NewSearchButton.vue
// module chunks = 54